import type { PropsWithChildren, ReactElement } from "react";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import type { WizardFooterProps } from "../WizardFooter/WizardFooter";
import WizardFooter from "../WizardFooter/WizardFooter";
import {
    StyledScrollableContainer,
    StyledWizardContentContainer,
    StyledWizardFooterWrapper,
    StyledWizardQuestionDescription,
    StyledWizardQuestionTitle
} from "./styles";
import {
    StyledWizardAnimationItem,
    WIZARD_ANIMATION_DELAY,
    WIZARD_ANIMATION_TIME
} from "app/pages/sales-intelligence/sub-modules/onboarding/wizard/styles";

interface Props extends WizardFooterProps {
    questionTitleKey: string;
    questionDescriptionKey: string;
    animatedChildren: number;
}

const WizardContentWrapper = ({
    questionTitleKey,
    questionDescriptionKey,
    animatedChildren,
    children,
    ...footerProps
}: PropsWithChildren<Props>): ReactElement => {

    return (
        <StyledWizardContentContainer>
            <StyledWizardAnimationItem>
                <I18n
                    translatable={{ key: questionTitleKey }}
                    element={StyledWizardQuestionTitle}
                />

                <I18n
                    translatable={{ key: questionDescriptionKey }}
                    element={StyledWizardQuestionDescription}
                />
            </StyledWizardAnimationItem>

            <StyledScrollableContainer>
                {children}


                <StyledWizardFooterWrapper>
                    <StyledWizardAnimationItem
                        delay={(animatedChildren + 1) * WIZARD_ANIMATION_TIME + (WIZARD_ANIMATION_DELAY * 2)}>
                        <WizardFooter {...footerProps} />
                    </StyledWizardAnimationItem>
                </StyledWizardFooterWrapper>
            </StyledScrollableContainer>
        </StyledWizardContentContainer>
    )
}

export default WizardContentWrapper;